import { render } from "./BagueCard.vue?vue&type=template&id=a67c5a4c&scoped=true"
import script from "./BagueCard.vue?vue&type=script&lang=js"
export * from "./BagueCard.vue?vue&type=script&lang=js"

import "./BagueCard.vue?vue&type=style&index=0&id=a67c5a4c&scoped=true&lang=css"

import exportComponent from "D:\\Data\\Bibliothèque\\Téléchargements\\public\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a67c5a4c"]])

export default __exports__